#version 300 es

precision highp float;



uniform sampler2D rttTexture;
uniform sampler2D rttTexturePrev;
uniform float rttSize;
uniform float screenSize;

uniform float extrapolationFactor;
uniform float renderStepSize;

out float speed;

vec4 advance(float position_) {
  if (position_ > (DENSITY / 1000.0) * screenSize * screenSize) {
    speed = 0.0;
    return vec4(0.0);
  }

  float x = fract(position_ / rttSize);
  float y = floor(position_ / rttSize) / rttSize;

  vec4 color = texture(rttTexture, vec2(x, y));
  vec2 pos = color.ba + color.rg / 255.0;

  vec4 colorPrev = texture(rttTexturePrev, vec2(x, y));
  vec2 posPrev = colorPrev.ba + colorPrev.rg / 255.0;

  vec2 diff = pos - posPrev;
  pos += diff * extrapolationFactor;

  speed =
    renderStepSize *
    step(0.0001, dot(posPrev, posPrev)) * // ignore initial zero
    length(diff * screenSize);

  return vec4(pos, diff);
}

void main() {
  float position_ = floor(position / 2.0);
  float vertex = 2.0 * fract(position / 2.0);

  vec4 posdiff = advance(position_);
  vec2 pos = posdiff.xy;
  vec2 dir = normalize(posdiff.zw);

  vec2 uv = (float(SIZE) / screenSize) * vec2(vertex, -vertex) * dir.yx;

  pos = 2.0 * (pos - uv) - 1.0;
  gl_Position = vec4(pos.x, -pos.y, 0., 1.);
}
